// ALL IMPORT
import GSvg from '@/components/Shared/Svg/GSvg';
import OptionsCenter from '@/components/Shared/OptionsCenter/OptionsCenter';
import RegisterSignIn from '@/components/Shared/Form/RegisterSignIn';
import RegisterSignUp from '@/components/Shared/Form/RegisterSignUp';
import ButtonConfirm from '@/components/Shared/Button/ButtonConfirm';
import Loader from '@/components/Shared/Loader/Loader';
import AlertStatus from '@/components/Shared/AlertStatus/AlertStatus';
import Forms from '@/components/Shared/Form/Forms';
import ProfileSetting from '@/components/Shared/ProfileSetting/ProfileSetting';
import NotYet from '@/components/Shared/NotYet/NotYet';
import NormalButton from '@/components/Shared/Button/NormalButton';
import UploadFile from '@/components/Shared/UploadFile/UploadFile';
import SearchInputTable from '@/components/Shared/Search/SearchInputTable';
import Pagination from '@/components/Shared/Pagination/Pagination';

// EXPORT
export default [
  GSvg,
  OptionsCenter,
  RegisterSignIn,
  RegisterSignUp,
  ButtonConfirm,
  Loader,
  AlertStatus,
  Forms,
  ProfileSetting,
  NotYet,
  NormalButton,
  UploadFile,
  SearchInputTable,
  Pagination
];
